import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SegmentBUMapArrayModel,
  SegmentBUMapModel,
} from "../../models/SegmentBUMapModel";

const initialState: SegmentBUMapArrayModel = {
  all_segment_bu_Map: [],
  isSegmentBUMapsFetching: false,
};
const SegmentBUMapSlice = createSlice({
  name: "SegmentBUMap",
  initialState: initialState,
  reducers: {
    setSegmentBUMap(state, action: PayloadAction<SegmentBUMapModel[]>) {
      state.all_segment_bu_Map = action.payload;
    },
    setIsSegmentBUMapsFetching(state, action: PayloadAction<boolean>) {
      state.isSegmentBUMapsFetching = action.payload;
    },
  },
});
export default SegmentBUMapSlice;
